import { Fence, ShieldCheck, EyeOff, MapPin } from "lucide-react";
import { SERVICE_AREA_SHORT_AREAS } from "@/config/business";

/**
 * TrustBar
 *
 * Slim, always-visible strip under the Navbar. Phase 1: numeric rating /
 * review-count claims removed (unverified) and the service-area chip now
 * reflects the real coverage config in src/lib/service-area.ts.
 */
const TrustBar = () => {
  return (
    <div
      className="w-full bg-primary text-primary-foreground border-b border-primary/80"
      role="region"
      aria-label="Trust signals"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <ul className="flex items-center justify-center gap-x-4 gap-y-1 flex-wrap py-1.5 text-[11px] sm:text-xs font-medium">
          <li className="flex items-center gap-1.5">
            <Fence className="w-3.5 h-3.5" aria-hidden />
            <span>Physical, non-electric fencing</span>
          </li>
          <li aria-hidden className="opacity-40">
            ·
          </li>
          <li className="flex items-center gap-1.5">
            <ShieldCheck className="w-3.5 h-3.5" aria-hidden />
            <span>Licensed &amp; insured</span>
          </li>
          <li aria-hidden className="opacity-40 hidden sm:inline">
            ·
          </li>
          <li className="hidden sm:flex items-center gap-1.5">
            <EyeOff className="w-3.5 h-3.5" aria-hidden />
            <span>Minimal visual impact</span>
          </li>
          <li aria-hidden className="opacity-40 hidden md:inline">
            ·
          </li>
          <li className="flex w-full justify-center items-start gap-1.5 text-center">
            <MapPin className="w-3.5 h-3.5 shrink-0 mt-0.5" aria-hidden />
            <span>Serving {SERVICE_AREA_SHORT_AREAS}</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TrustBar;
